import axios from "../Axios";

export const createLogs = (payload) => {
  return axios.post(`/v1/audit-logs`, payload);
};
